
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class PIcon extends Vue {
  @Prop({ required: true })
  icon!: string;
  @Prop({ required: false, default: "default" })
  type!: string;
  @Prop({ required: false, default: "p_icon" })
  iclass!: string;
  verMaterial = false;
  get classIcon(): string {
    if (this.verMaterial) {
      return "material-icons " + this.iclass + "_material";
    } else {
      return this.icon + " " + this.iclass + " " + "p_icon_min_size";
    }
  }

  mounted(): void {
    if (this.type === "material-icons") {
      this.verMaterial = true;
    }
  }
}
